import { render, staticRenderFns } from "./JamoatchilikKengashi.vue?vue&type=template&id=2f6ebc5a&"
import script from "./JamoatchilikKengashi.vue?vue&type=script&lang=js&"
export * from "./JamoatchilikKengashi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports